__webpack_require__.p = "https://c.academia-assets.com/webpack_bundles/";